<template>
  <b-modal
    id="modal-update-resource"
    ref="modal-resource"
    :visible="visible"
    @hidden="hidden"
    :no-close-on-backdrop="loading"
    :no-close-on-esc="loading"
    centered
  >
    <template #modal-header>
      <h5 class="modal-title">ویرایش منبع</h5>
    </template>
    <error-messages
      :show="showError"
      :dismissible="true"
      @dismissed="dismissedError"
      :messages="errorMessages"
    />
    <b-form @submit.stop.prevent="updateResourceSubmit">
      <b-form-group>
        <label>کمترین مقدار منبع</label>
        <b-form-input
          type="text"
          @update="minValueUpdated"
          :state="this.validMinValue"
          v-model="form.minValue.value"
        />
        <b-form-invalid-feedback class="text-right" :state="this.validMinValue">
          {{ form.minValue.error }}
        </b-form-invalid-feedback>
      </b-form-group>
      <b-form-group>
        <label>بیشترین مقدار منبع</label>
        <b-form-input
          type="text"
          @update="maxValueUpdated"
          :state="this.validMaxValue"
          v-model="form.maxValue.value"
        />
        <b-form-invalid-feedback class="text-right" :state="this.validMaxValue">
          {{ form.maxValue.error }}
        </b-form-invalid-feedback>
      </b-form-group>
      <b-form-group>
        <label>واحد افزایشی</label>
        <b-form-input
          type="text"
          @update="growthRateUpdated"
          :state="this.validGrowthRate"
          v-model="form.growthRate.value"
        />
        <b-form-invalid-feedback
          class="text-right"
          :state="this.validGrowthRate"
        >
          {{ form.growthRate.error }}
        </b-form-invalid-feedback>
      </b-form-group>
      <b-form-group>
        <label>قیمت هر واحد</label>
        <b-form-input
          type="text"
          @update="pricePerUnitUpdated"
          :state="this.validPricePerUnit"
          v-model="form.pricePerUnit.value"
        />
        <b-form-invalid-feedback
          class="text-right"
          :state="this.validPricePerUnit"
        >
          {{ form.pricePerUnit.error }}
        </b-form-invalid-feedback>
      </b-form-group>
    </b-form>
    <template #modal-footer>
      <b-button variant="secondary" @click="hidden" :disabled="loading">
        انصراف
      </b-button>
      <loading-btn
        :loading="loading"
        :disabled="okDisabled || loading"
        @click="updateResourceSubmit"
      >
        بروزرسانی
      </loading-btn>
    </template>
  </b-modal>
</template>

<script>
import { resourceUpdate } from "@/services/resource";
import LoadingBtn from "@/components/LoadingBtn/LoadingBtn.vue";
import ErrorMessages from "@/components/ErrorMessages/ErrorMessages.vue";

export default {
  components: { LoadingBtn, ErrorMessages },
  name: "CreateFtpModal",
  props: {
    visible: Boolean,
    resourceId: Number
  },
  data() {
    return {
      loading: false,
      form: {
        minValue: { value: "", error: "" },
        maxValue: { value: "", error: "" },
        growthRate: { value: "", error: "" },
        pricePerUnit: { value: "", error: "" }
      },
      validMinValue: null,
      validMaxValue: null,
      validGrowthRate: null,
      validPricePerUnit: null,
      okDisabled: true,
      showError: false,
      errorMessages: []
    };
  },
  methods: {
    reset: function() {
      this.form = {
        minValue: { value: "", error: "" },
        maxValue: { value: "", error: "" },
        growthRate: { value: "", error: "" },
        pricePerUnit: { value: "", error: "" }
      };
      this.validMinValue = null;
      this.validMaxValue = null;
      this.validGrowthRate = null;
      this.validPricePerUnit = null;
    },
    dismissedError: function() {
      this.showError = false;
    },
    hidden: function() {
      this.reset();
      this.$emit("hidden");
    },
    updateResourceSubmit: async function() {
      this.loading = true;
      const [error, data] = await resourceUpdate({
        id: this.resourceId,
        minValue: this.form.minValue.value,
        maxValue: this.form.maxValue.value,
        growthRate: this.form.growthRate.value,
        pricePerUnit: this.form.pricePerUnit.value
      });
      if (error) {
        this.errorMessages = error;
        this.showError = true;
        this.loading = false;
      } else {
        if (data.apiStatus === 200) {
          this.$emit("updatedSuccess");
          this.hidden();
          this.loading = false;
        } else {
          this.errorMessages = data.apiErrors;
          this.showError = true;
          this.loading = false;
        }
      }
    },
    minValueUpdated: function(val) {
      if (val === "") {
        this.form.minValue.error = "کمترین مقدار برای منبع الزامی است.";
        this.validMinValue = false;
      } else {
        this.form.minValue.error = "";
        this.validMinValue = true;
      }
    },
    maxValueUpdated: function(val) {
      if (val === "") {
        this.form.maxValue.error = "بیشترین مقدار برای منبع الزامی است.";
        this.validMaxValue = false;
      } else {
        this.form.maxValue.error = "";
        this.validMaxValue = true;
      }
    },
    growthRateUpdated: function(val) {
      if (val === "") {
        this.form.growthRate.error = "واحد افزایشی برای منبع الزامی است.";
        this.validGrowthRate = false;
      } else {
        this.form.growthRate.error = "";
        this.validGrowthRate = true;
      }
    },
    pricePerUnitUpdated: function(val) {
      if (val === "") {
        this.form.pricePerUnit.error = "قیمت برای هر واحد از منبع الزامی است.";
        this.validPricePerUnit = false;
      } else {
        this.form.pricePerUnit.error = "";
        this.validPricePerUnit = true;
      }
    }
  },
  updated() {
    if (
      this.validMinValue &&
      this.validMaxValue &&
      this.validGrowthRate &&
      this.validPricePerUnit
    ) {
      this.okDisabled = false;
    } else {
      this.okDisabled = true;
    }
  }
};
</script>
